<template>
  <div class="headerBox">
    <div>
      <p>可用余额</p>
      <div class="members">
        <img src="../../assets/imges/钱包.png" alt="" />
        <span> ￥{{ this.$store.state.userInfo.Balance }}</span>
        <el-button
          style="
            font-size: 0.6rem;
            padding: 5px;
            width: 50px;
            margin-left: 20px;
          "
          type="warning"
          @click="dialogFormVisible = true"
          plain
          >充值</el-button
        >
      </div>
    </div>
    <div>
      <p>可用积分</p>
      <div class="members">
        <img src="../../assets/imges/积分.png" alt="" />
        <span>{{ this.$store.state.userInfo.Integral }}</span>
        <el-button
          style="
            font-size: 0.6rem;
            padding: 5px;
            width: 60px;
            margin-left: 20px;
          "
          type="warning"
          plain
          @click="clickSign"
          >点击签到</el-button
        >
      </div>
    </div>
    <div>
      <p>在线客服</p>
      <div class="members">
        <img src="../../assets/imges/客服.png" alt="" />
        <div>
          <div>
            <a
              href="http://wpa.qq.com/msgrd?v=3&amp;uin=574039568&amp;site=qq&amp;menu=yes"
            >
              <el-button
                style="font-size: 0.5rem; padding: 5px"
                type="primary"
                plain
                >在线客服</el-button
              >
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- 微信支付二维码 -->
    <el-dialog title="充值" width="30%" :visible.sync="isPay">
      <img style="width:200px;height: 200px;" :src="payImg" alt="">
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelPay">取 消</el-button>
        <el-button type="primary" @click="cancelPay">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 充值对话框 -->
    <el-dialog title="充值" width="30%" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item style="display: flex" label="充值金额:">
          <el-input @blur="twoNunan" v-model="form.amount" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item style="display: flex" label="支付方式:">
          <el-select
            v-model="form.region"
            autocomplete="off"
            placeholder="请选择活动区域"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="Determine"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getPay } from '../../api/http/pay';
import { getUser } from "../../api/http/user";

export default {
  data() {
    return {
      dialogFormVisible: false,
      form: {
        amount: '0',
        region: "1",
      },
      payImg:'',//支付接口二维码
      isPay: false,
      options: [
        { label: "微信支付", value: "1" },
        { label: "支付宝支付", value: "2" },
      ],
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    twoNunan(){
      this.form.amount=parseFloat(this.form.amount).toFixed(2)
    },
    // 取消支付对话框
    cancelPay(){
      this.isPay=false
      this.getUserInfo()
    },
    // 支付接口
    Determine(){
      if(this.form.region=="1"){
       getPay.setTopUpWeChatPay({Money:this.form.amount}).then(res=>{
        if(res.data.code==200){
          this.dialogFormVisible=false
          this.isPay=true
           this.payImg="https://api.pwmqr.com/qrcode/create/?url="+res.data.data
        }else{
          this.dialogFormVisible=false
          this.$message({
            message:res.data.msg,
            type:"error"
          })
        }
       })
      }else if(this.form.region=="2"){
        getPay.TopUpAlipayPay({Money:parseFloat(parseFloat(this.form.amount).toFixed(2))}).then(res=>{
          if(res.data.code){
              this.$router.push({
              path: "/alipay",
              query: { htmls: res.data.data },
            });
          }else{
            this.$message({
              message:res.data.msg,
              type:"error"
            })
          }
        })

      }
    },
    clickSign() {
      getUser.getTodaysign().then((res) => {
        if (res.data.code == 200) {
          getUser.getSign().then((res) => {
            if (res.data.code == 200) {
              this.getUserInfo();
              this.$message({
                message: "签到成功！",
                type: "success",
              });
            } else {
              this.$message({
                message: "签到失败！",
                type: "erroe",
              });
            }
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
      this.getUserInfo();
    },
    getUserInfo() {
      getUser.getUse().then((res) => {
        if (res.data.code == 200) {
          this.$store.commit("getUserInfo", res.data.data);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.headerBox {
  width: 90%;
  margin: auto;
  margin-top: 2rem;
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: space-around;
  div {
    text-align: center;
    div {
      flex: 1;
    }
    .members {
      display: flex;
      align-items: center;
    }
    img {
      width: 2rem;
      height: 2rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/box/headerbox.vue